<template>
   <div class="innerView" style="margin-top:5px;border: 1px solid #ddd;" :style="{height:height}">
     <mw-view :id="viewId" ref="view" :tableParams="tableParams" :params="formConfig" :formValue="formValue"></mw-view>
   </div>

</template>
<script>
  export default
  {
    name:'form-imbedded-view',
    data() {
      return {
        viewId:'',
        tableParams:{},
        formValue:{},
        height:"350px",
        formConfig:{
          getForm:this.$options.config.getForm,
          config:this.$options.config.getConfig(),
          way:'inner'
        },
      }
    },
    created() {

    },
    mounted() {
      let me=this;
      let config=this.$options.config.getConfig();
      if (config.style && config.style.height || config.bodyStyle && config.bodyStyle.height){
        me.height="100%";
      }
      let id=config.viewId;

      if(id){
        this.viewId=id;
       /* if(config.relatedField){
          //let v=config.relatedField.split("|");
        }else{*/
        //}
      /*  if(config.relatedCondition){
          //config.relatedField.split("|");
        }else{*/
        //}

      }
      me.setTableParams();
      let oldTableParams=_.clone(me.tableParams);
      let form=me.$options.config.getForm();
      let refreshView=_.debounce(function(){
        me.$refs.view.refresh();
      },400);
      form.on("change",v=>{
        me.setTableParams();
        if (!_.isEqual(me.tableParams, oldTableParams)) {
          refreshView();
        }
        oldTableParams=_.clone(me.tableParams);
      });
    },

    methods: {
      setTableParams() {
        let me=this;
        let form=me.$options.config.getForm();
        let config=me.$options.config.getConfig();
        let formValues=form.getValue();
        // let value=this.$options.config.getFormValue();
        let businessId=this.$options.config.getData().businessId;
        if(!businessId){
           businessId= formValues.id || this.$options.config.getData().tempBusinessId
        }
        me.tableParams.initrelateid=businessId;
        // me.formConfig.formeditform = form.__originalExtForm.editMode;
        let fieldObj=form.find(config.name);
        if(fieldObj && fieldObj.textMode!==undefined) {
          me.formConfig.formeditform = !fieldObj.textMode;
        }else if(fieldObj && fieldObj.readOnly===true){
          me.formConfig.formeditform=false;
        }else{
          me.formConfig.formeditform = !form.isTextMode();
        }
        me.formValue.initrelateid=businessId;
        if(config.relatedField){
          delete me.tableParams.initrelateid; //有配置了后不需要默认的。否则可以查询不出来数据。
          _(config.relatedField).split(",").map(f => f.indexOf("|") ? f.split("|") : [f, f]
          ).each(pairs => {
            me.tableParams[pairs[0]]=formValues[pairs[1]];
            me.formValue[pairs[0]]=formValues[pairs[1]];
          });
        }
      },
      getToolbarTable(){
        return this.getViewObject().mwRef("toolbarTable");
      },
      getViewObject(){
        return this.$refs.view.$viewObj;
      }
    },

    destroyed(){

    }
  }
</script>



// WEBPACK FOOTER //
// src/common/components/extend/form/src/components/imbeddedView.vue